import React from 'react';
import { Typography } from '@material-ui/core';

import HealthPlanVisitTypeChip from './HealthPlanVisitTypeChip/HealthPlanTypeChip';
import ModernHealthVisitTypeChip from './ModernHealthVisitTypeChip/ModernHealthVisitTypeChip';
import { checkIsModernHealthVisitType } from './helpers';

type Props = {
  visitType: string;
};

const VisitTypeChip: React.FC<Props> = ({ visitType }) => {
  const isModernHealthVisitType = checkIsModernHealthVisitType(visitType);

  return (
    <div>
      <Typography>
        {isModernHealthVisitType && <ModernHealthVisitTypeChip />}

        {!isModernHealthVisitType && <HealthPlanVisitTypeChip />}
      </Typography>
    </div>
  );
};

export default VisitTypeChip;
